import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './translations/en.json'

Vue.use(VueI18n)

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  de: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
  },
  el: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}

// const numberFormats = {
//   en: {
//     unit: {
//       style: 'unit',
//       unit: 'metre+3',
//     },
//   },
//   de: {
//     unit: {
//       style: 'unit',
//       unit: 'metre+3',
//     },
//   },
// }

const availableLanguages = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'de',
    label: 'Deutsch',
  },
  {
    value: 'el',
    label: 'Ελληνικά',
  },
  {
    value: 'pl',
    label: 'Polskie',
  },
  {
    value: 'fr',
    label: 'Français',
  },
]

function setI18nLanguage(lang) {
  i18n.locale = lang
  return lang
}

function loadCalendarLanguage(lang) {
  if (lang === 'el') {
    return import(`vue2-datepicker/locale/el`)
  }
  if (lang === 'de') {
    return import(`vue2-datepicker/locale/de`)
  }
  if (lang === 'pl') {
    return import(`vue2-datepicker/locale/pl`)
  }
  if (lang === 'fr') {
    return import(`vue2-datepicker/locale/fr`)
  }

  return import(`vue2-datepicker/locale/en`)
}

function loadLanguageAsync(lang) {
  if (i18n.locale === lang || i18n.availableLocales.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  return import(/* webpackChunkName: "lang-[request]" */ `./translations/${lang}.json`).then(
    messages => {
      loadCalendarLanguage(lang)
      i18n.setLocaleMessage(lang, messages.default)
      return setI18nLanguage(lang)
    }
  )
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
  },
  dateTimeFormats,
})

i18n.availableLanguages = availableLanguages
i18n.loadLanguageAsync = loadLanguageAsync

export default i18n
